import React from 'react';
import PropTypes from 'prop-types';
import {
  InformationStatsBlock,
  DescriptionParagraph,
  BlockHeading,
} from './styles.js';

export const InfoStatBlock = ({
  heading,
  description,
  backgroundColor,
  textColor,
}) => {
  return (
    <InformationStatsBlock backgroundColor={backgroundColor}>
      <BlockHeading backgroundColor={backgroundColor} textColor={textColor}>
        {heading}
      </BlockHeading>
      <DescriptionParagraph textColor={textColor}>
        {description}
      </DescriptionParagraph>
    </InformationStatsBlock>
  );
};

InfoStatBlock.displayName = 'InfoStatBlock';

InfoStatBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};
